/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FileAccessResponseBody,
  InvoiceItemCsvExportSummary,
  InvoiceSummary,
  InvoiceTotals,
  PagedAndSyncedResultInvoiceSummary,
  PaymentMethod,
  PaymentStatus,
  SortDirection,
} from '../models/index';
import {
    FileAccessResponseBodyFromJSON,
    FileAccessResponseBodyToJSON,
    InvoiceItemCsvExportSummaryFromJSON,
    InvoiceItemCsvExportSummaryToJSON,
    InvoiceSummaryFromJSON,
    InvoiceSummaryToJSON,
    InvoiceTotalsFromJSON,
    InvoiceTotalsToJSON,
    PagedAndSyncedResultInvoiceSummaryFromJSON,
    PagedAndSyncedResultInvoiceSummaryToJSON,
    PaymentMethodFromJSON,
    PaymentMethodToJSON,
    PaymentStatusFromJSON,
    PaymentStatusToJSON,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/index';

export interface DownloadInvoiceDocumentRequest {
    downloadToken: string;
}

export interface GetDetailOfInvoiceRequest {
    invoiceNumber: number;
}

export interface GetInvoiceSummariesOfCurrentRetailerRequest {
    offset?: number;
    limit?: number;
    createdBetweenFrom?: Date;
    createdBetweenUntil?: Date;
    paymentMethod?: PaymentMethod;
    fullTextQuery?: string;
    paymentStatus?: Array<PaymentStatus>;
    sortByCreatedAt?: SortDirection;
    sortByPaymentMethod?: SortDirection;
    sortByPaymentStatus?: SortDirection;
    sortByShippingAddressName?: SortDirection;
    sortByShippingStatus?: SortDirection;
    sortByTotal?: SortDirection;
    sortByTransactionNumber?: SortDirection;
    sortByInvoiceReference?: SortDirection;
}

export interface GetInvoiceSummariesOfCurrentRetailerCsvExportRequest {
    createdBetweenFrom?: Date;
    createdBetweenUntil?: Date;
    paymentMethod?: PaymentMethod;
    fullTextQuery?: string;
    paymentStatus?: Array<PaymentStatus>;
}

export interface RequestInvoiceDownloadRequest {
    companyCode: string;
    invoiceNumber: number;
}

/**
 * 
 */
export class InvoiceResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for downloadInvoiceDocument without sending the request
     */
    async downloadInvoiceDocumentRequestOpts(requestParameters: DownloadInvoiceDocumentRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['downloadToken'] == null) {
            throw new runtime.RequiredError(
                'downloadToken',
                'Required parameter "downloadToken" was null or undefined when calling downloadInvoiceDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/invoice/download/{downloadToken}`;
        urlPath = urlPath.replace(`{${"downloadToken"}}`, encodeURIComponent(String(requestParameters['downloadToken'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async downloadInvoiceDocumentRaw(requestParameters: DownloadInvoiceDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const requestOptions = await this.downloadInvoiceDocumentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async downloadInvoiceDocument(requestParameters: DownloadInvoiceDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.downloadInvoiceDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDetailOfInvoice without sending the request
     */
    async getDetailOfInvoiceRequestOpts(requestParameters: GetDetailOfInvoiceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['invoiceNumber'] == null) {
            throw new runtime.RequiredError(
                'invoiceNumber',
                'Required parameter "invoiceNumber" was null or undefined when calling getDetailOfInvoice().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/invoice/{invoiceNumber}`;
        urlPath = urlPath.replace(`{${"invoiceNumber"}}`, encodeURIComponent(String(requestParameters['invoiceNumber'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getDetailOfInvoiceRaw(requestParameters: GetDetailOfInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvoiceSummary>> {
        const requestOptions = await this.getDetailOfInvoiceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvoiceSummaryFromJSON(jsonValue));
    }

    /**
     */
    async getDetailOfInvoice(requestParameters: GetDetailOfInvoiceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvoiceSummary> {
        const response = await this.getDetailOfInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getInvoiceSummariesOfCurrentRetailer without sending the request
     */
    async getInvoiceSummariesOfCurrentRetailerRequestOpts(requestParameters: GetInvoiceSummariesOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['createdBetweenFrom'] != null) {
            queryParameters['createdBetweenFrom'] = (requestParameters['createdBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['createdBetweenUntil'] != null) {
            queryParameters['createdBetweenUntil'] = (requestParameters['createdBetweenUntil'] as any).toISOString();
        }

        if (requestParameters['paymentMethod'] != null) {
            queryParameters['paymentMethod'] = requestParameters['paymentMethod'];
        }

        if (requestParameters['fullTextQuery'] != null) {
            queryParameters['fullTextQuery'] = requestParameters['fullTextQuery'];
        }

        if (requestParameters['paymentStatus'] != null) {
            queryParameters['paymentStatus'] = requestParameters['paymentStatus'];
        }

        if (requestParameters['sortByCreatedAt'] != null) {
            queryParameters['sortByCreatedAt'] = requestParameters['sortByCreatedAt'];
        }

        if (requestParameters['sortByPaymentMethod'] != null) {
            queryParameters['sortByPaymentMethod'] = requestParameters['sortByPaymentMethod'];
        }

        if (requestParameters['sortByPaymentStatus'] != null) {
            queryParameters['sortByPaymentStatus'] = requestParameters['sortByPaymentStatus'];
        }

        if (requestParameters['sortByShippingAddressName'] != null) {
            queryParameters['sortByShippingAddressName'] = requestParameters['sortByShippingAddressName'];
        }

        if (requestParameters['sortByShippingStatus'] != null) {
            queryParameters['sortByShippingStatus'] = requestParameters['sortByShippingStatus'];
        }

        if (requestParameters['sortByTotal'] != null) {
            queryParameters['sortByTotal'] = requestParameters['sortByTotal'];
        }

        if (requestParameters['sortByTransactionNumber'] != null) {
            queryParameters['sortByTransactionNumber'] = requestParameters['sortByTransactionNumber'];
        }

        if (requestParameters['sortByInvoiceReference'] != null) {
            queryParameters['sortByInvoiceReference'] = requestParameters['sortByInvoiceReference'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/invoice`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getInvoiceSummariesOfCurrentRetailerRaw(requestParameters: GetInvoiceSummariesOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedAndSyncedResultInvoiceSummary>> {
        const requestOptions = await this.getInvoiceSummariesOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedAndSyncedResultInvoiceSummaryFromJSON(jsonValue));
    }

    /**
     */
    async getInvoiceSummariesOfCurrentRetailer(requestParameters: GetInvoiceSummariesOfCurrentRetailerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedAndSyncedResultInvoiceSummary> {
        const response = await this.getInvoiceSummariesOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getInvoiceSummariesOfCurrentRetailerCsvExport without sending the request
     */
    async getInvoiceSummariesOfCurrentRetailerCsvExportRequestOpts(requestParameters: GetInvoiceSummariesOfCurrentRetailerCsvExportRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['createdBetweenFrom'] != null) {
            queryParameters['createdBetweenFrom'] = (requestParameters['createdBetweenFrom'] as any).toISOString();
        }

        if (requestParameters['createdBetweenUntil'] != null) {
            queryParameters['createdBetweenUntil'] = (requestParameters['createdBetweenUntil'] as any).toISOString();
        }

        if (requestParameters['paymentMethod'] != null) {
            queryParameters['paymentMethod'] = requestParameters['paymentMethod'];
        }

        if (requestParameters['fullTextQuery'] != null) {
            queryParameters['fullTextQuery'] = requestParameters['fullTextQuery'];
        }

        if (requestParameters['paymentStatus'] != null) {
            queryParameters['paymentStatus'] = requestParameters['paymentStatus'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/invoice/export-csv`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getInvoiceSummariesOfCurrentRetailerCsvExportRaw(requestParameters: GetInvoiceSummariesOfCurrentRetailerCsvExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InvoiceItemCsvExportSummary>>> {
        const requestOptions = await this.getInvoiceSummariesOfCurrentRetailerCsvExportRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvoiceItemCsvExportSummaryFromJSON));
    }

    /**
     */
    async getInvoiceSummariesOfCurrentRetailerCsvExport(requestParameters: GetInvoiceSummariesOfCurrentRetailerCsvExportRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InvoiceItemCsvExportSummary>> {
        const response = await this.getInvoiceSummariesOfCurrentRetailerCsvExportRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getInvoiceTotalsByPaymentStatusOfCurrentRetailer without sending the request
     */
    async getInvoiceTotalsByPaymentStatusOfCurrentRetailerRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/invoice/total`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getInvoiceTotalsByPaymentStatusOfCurrentRetailerRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<InvoiceTotals>>> {
        const requestOptions = await this.getInvoiceTotalsByPaymentStatusOfCurrentRetailerRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InvoiceTotalsFromJSON));
    }

    /**
     */
    async getInvoiceTotalsByPaymentStatusOfCurrentRetailer(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<InvoiceTotals>> {
        const response = await this.getInvoiceTotalsByPaymentStatusOfCurrentRetailerRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for requestInvoiceDownload without sending the request
     */
    async requestInvoiceDownloadRequestOpts(requestParameters: RequestInvoiceDownloadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['companyCode'] == null) {
            throw new runtime.RequiredError(
                'companyCode',
                'Required parameter "companyCode" was null or undefined when calling requestInvoiceDownload().'
            );
        }

        if (requestParameters['invoiceNumber'] == null) {
            throw new runtime.RequiredError(
                'invoiceNumber',
                'Required parameter "invoiceNumber" was null or undefined when calling requestInvoiceDownload().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['companyCode'] != null) {
            queryParameters['companyCode'] = requestParameters['companyCode'];
        }

        if (requestParameters['invoiceNumber'] != null) {
            queryParameters['invoiceNumber'] = requestParameters['invoiceNumber'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/invoice/download`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async requestInvoiceDownloadRaw(requestParameters: RequestInvoiceDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileAccessResponseBody>> {
        const requestOptions = await this.requestInvoiceDownloadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileAccessResponseBodyFromJSON(jsonValue));
    }

    /**
     */
    async requestInvoiceDownload(requestParameters: RequestInvoiceDownloadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileAccessResponseBody> {
        const response = await this.requestInvoiceDownloadRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
